import * as actions from 'actions';
import byIdMaker from 'reducersMakers/byIdMaker';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.CHAT_DOCUMENTS_RECEIVED
  ],
  entityType: 'chatDocuments'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatDocuments/byId/reducer.js
 **/